export default __webpack_public_path__ + "static/media/text-block-white.1d00e026.svg";